import { ChildAvailabilitySearchResultsSchema } from '@sola/schema/lib/skippy.js';

export const useSessionStorage = () => {
  return {
    get: (name: string) => {
      return sessionStorage.getItem(name);
    },
    set: (name: string | string[], item: string | string[]): void => {
      if (typeof name === 'string' && typeof item === 'string') {
        sessionStorage.setItem(name, item);
      } else if (
        Array.isArray(name) &&
        Array.isArray(item) &&
        name.length === item.length
      ) {
        name.forEach((e, index) => {
          sessionStorage.setItem(e, item[index]);
        });
      }
    },
    compare: (names: string[], items: string[]) => {
      if (names.length !== items.length) {
        return false;
      }
      for (let i = 0; i < names.length; i++) {
        if (sessionStorage.getItem(names[i]) !== items[i]) {
          return false;
        }
      }
      return true;
    },
    remove: (name: string) => {
      sessionStorage.removeItem(name);
    },
    readChildStore: () => {
      return sessionStorage.getItem('sacChildren') &&
        sessionStorage.getItem('sacChildren') !== null
        ? ChildAvailabilitySearchResultsSchema.parse(
            JSON.parse(sessionStorage.getItem('sacChildren') as string),
          )
        : null;
    },
  };
};
